module.exports = __webpack_public_path__ + "img/1970East-064_WEB-min.ed04abd1.jpg";